import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {TranslocoPipe} from '@jsverse/transloco';
import {LanguageSwitcherComponent} from '../../shared/language-switcher/language-switcher.component';

@Component({
  selector: 'app-account-layout',
  imports: [RouterOutlet, LanguageSwitcherComponent, TranslocoPipe],
  templateUrl: './account-layout.component.html',
  styleUrl: './account-layout.component.scss',
})
export class AccountLayoutComponent {}
